export default {
  // list
  'crm_customer_car.column.customerId': 'customerId',
  'crm_customer_car.column.carNo': 'carNo',
  'crm_customer_car.column.contactId': 'contactId',
  'crm_customer_car.column.enableFlag': 'enableFlag',
  'crm_customer_car.column.createBy': 'createBy',
  'crm_customer_car.column.updateBy': 'updateBy',
  'crm_customer_car.column.createTime': 'createTime',
  'crm_customer_car.column.updateTime': 'updateTime',
  'crm_customer_car.column.dataSource': 'dataSource',
  'crm_customer_car.column.remark': 'remark',
  'crm_customer_car.column.status': 'status',
  // edit
  'crm_customer_car.edit.title': 'Edit CrmCustomerCar',
  'crm_customer_car.add.title': 'Add CrmCustomerCar',
  'crm_customer_car.edit.success': 'Edit Successful',
  'crm_customer_car.add.success': 'Add Successful',
  'crm_customer_car.form.carNo.required': 'carNo cannot be null',
  'crm_customer_car.form.contactId.required': 'contactId cannot be null',
  'crm_customer_car.form.enableFlag.required': 'enableFlag cannot be null',
  'crm_customer_car.form.carNo': 'carNo',
  'crm_customer_car.form.carNo.placeholder': 'Enter carNo',
  'crm_customer_car.form.contactId': 'contactId',
  'crm_customer_car.form.contactId.placeholder': 'Enter contactId',
  'crm_customer_car.form.enableFlag': 'enableFlag',
  'crm_customer_car.form.enableFlag.placeholder': 'Enter enableFlag',
}
